export const LOGIN_STATUS_KNOWN: 'LOGIN/STATUS_KNOWN' = 'LOGIN/STATUS_KNOWN';
export const SAVE_REDIRECT: 'LOGIN/SAVE_REDIRECT' = 'LOGIN/SAVE_REDIRECT';
export const CLEAR_REDIRECT: 'LOGIN/CLEAR_REDIRECT' = 'LOGIN/CLEAR_REDIRECT';
export const CHANGE_MIGROS_LOGIN_STATUS: 'LOGIN/CHANGE_MIGROS_LOGIN_STATUS' = 'LOGIN/CHANGE_MIGROS_LOGIN_STATUS';
